import { createReducer, on, Action } from '@ngrx/store';
import * as ProductActions from './products.actions';
import { cloneDeep } from 'lodash';

export const PRODUCTS_FEATURE_KEY = 'products';

export interface State {
  productDetails: {
    data: any;
    loading: boolean;
    error: string;
  };
}

const initialState: State = {
  productDetails: {
    data: null,
    loading: false,
    error: '',
  },
};

const _reducer = createReducer(
  { ...initialState },

   on(ProductActions.getProduct, (state: State) => {
    const _state = cloneDeep(state);
    _state.productDetails.loading = true;
    return _state;
  }),
  on(ProductActions.getProductSuccess, (state: State, { product }) => {
    const _state = cloneDeep(state);
    _state.productDetails.loading = false;
    _state.productDetails.data = product;
    _state.productDetails.error = '';
    return _state;
  }),
  on(ProductActions.getProductFailure, (state: State, { error }) => {
    const _state = cloneDeep(state);
    _state.productDetails.loading = false;
    _state.productDetails.error = error.message;
    return _state;
  }),
);

export function reducer(state: State, action: Action) {
  return _reducer(state, action);
}
